import {Outlet} from "react-router-dom"
import classes from "./Auth.module.scss"

export default function Auth() {
  return (
    <div className={classes.wrap}>
      <Outlet/>
    </div>
  )
}